import * as React from 'react';
import type { SVGProps } from 'react';

const SvgBundle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={48}
    height={48}
    {...props}
  >
    <defs>
      <filter
        id="bundle_svg__a"
        width="108.3%"
        height="110.5%"
        x="-4.1%"
        y="-5.2%"
        filterUnits="objectBoundingBox"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={7} />
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
      </filter>
      <filter
        id="bundle_svg__c"
        width="108.3%"
        height="110.5%"
        x="-4.1%"
        y="-5.2%"
        filterUnits="objectBoundingBox"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={7} />
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
      </filter>
      <rect id="bundle_svg__b" width={507} height={400} x={2} y={278} rx={6} />
      <rect id="bundle_svg__d" width={507} height={400} x={526} y={278} rx={6} />
      <path
        id="bundle_svg__e"
        d="M36.625 26.257v-4.264c0-.742-.597-1.339-1.34-1.339h-7.689v-7.69c0-.742-.597-1.339-1.34-1.339h-4.263c-.742 0-1.339.597-1.339 1.34v7.689h-7.69c-.742 0-1.339.597-1.339 1.34v4.263c0 .742.597 1.339 1.34 1.339h7.689v7.69c0 .742.597 1.339 1.34 1.339h4.263c.742 0 1.339-.597 1.339-1.34v-7.689h7.69c.742 0 1.339-.597 1.339-1.34Z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-493 -297)">
        <use xlinkHref="#bundle_svg__b" fill="#000" filter="url(#bundle_svg__a)" />
        <use xlinkHref="#bundle_svg__b" fill="#FFF" />
      </g>
      <g transform="translate(-493 -297)">
        <use xlinkHref="#bundle_svg__d" fill="#000" filter="url(#bundle_svg__c)" />
        <use xlinkHref="#bundle_svg__d" fill="#FFF" />
      </g>
      <g>
        <circle cx={24} cy={24} r={24} fill="#222426" />
        <mask id="bundle_svg__f" fill="#fff">
          <use xlinkHref="#bundle_svg__e" />
        </mask>
        <use xlinkHref="#bundle_svg__e" fill="#FFF" fillRule="nonzero" />
        <g mask="url(#bundle_svg__f)">
          <path d="M9.571 9.571h32.857v32.857H9.571z" />
        </g>
      </g>
    </g>
  </svg>
);
export default SvgBundle;
